<div class="row">
    <div class="col-sm-9">
      <div class="booking_ht">
  <!-- <sm-title-bar pageTitle="All employee log"></sm-title-bar> -->

  <sm-title-bar pageTitle="All employee log" [backWithParams]="true"></sm-title-bar>

  </div>
  </div>
  <div class="col-sm-3">
    <!-- <div class="search_bar_custom">
      <mat-form-field appearance="outline">
          <mat-label>Search</mat-label>
          <input matInput placeholder="Search for services">
          <button mat-icon-button matSuffix>
              <mat-icon>search</mat-icon>
          </button>
      </mat-form-field>
  </div> -->
  </div>
  </div>
  
  <mat-card *ngIf="!loader && employeeLogData.length > 0">
      <div class="rounded-3 bg-light">
        <sm-data-table [columnHeaders]="tableDisplayColumns" 
                       [showImageColumn]="true" 
                       [imageTemplate]="image" 
                       [dataSource]="employeeLogData"
                       [showPagination]="true" 
                       [itemsPerPage]="25">
        </sm-data-table>
      </div>
    </mat-card>
    
    <ng-template #menuTemplate let-rowvalue>
      <button mat-menu-item>
        <mat-icon class="material-icons-outlined">check_circle</mat-icon>
        <span>Edit</span>
      </button>
      <button mat-menu-item>
        <mat-icon class="material-icons-outlined">timer</mat-icon>
        <span>Delete</span>
      </button>
    </ng-template>
    
  
    
    <ng-template #image let-objValue>
      <img
        [src]="
          objValue['image_thumb_url'] !== null && objValue['image_thumb_url'] !== 'null' && objValue['image_thumb_url'] !== ''
            ? objValue['image_thumb_url']
            : './assets/images/photo.png'
        "
        class="img-fluid rounded-circle"
      />
    </ng-template>